import {
  Box,
  Button,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Checkbox,
  FormGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Fpm.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setSavingsState,
  setQ3sState,
  setFspType,
  setSavingOtherText,
  setLoansState,
  setInsurancesState,
} from "../features/fpmSlice/FmpSlice";
import Swal from "sweetalert2";
import Logo from "../images/logo_quick-learning-tool.png";

function FpmPage2Fil() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [othersText, setOthersText] = useState();

  const [savingState, setSavingState] = useState({
    sCheck1: false,
    sCheck2: false,
    sCheck3: false,
    sCheck4: false,
    sCheck5: false,
    sCheck6: false,
    sCheck7: false,
    sCheck8: false,
    sCheck9: false,
  });

  const [loanState, setLoanState] = useState({
    lCheck1: false,
    lCheck2: false,
    lCheck3: false,
    lCheck4: false,
    lCheck5: false,
    lCheck6: false,
    lCheck7: false,
    lCheck8: false,
    lCheck9: false,
    lCheck10: false,
    lCheck11: false,
  });

  const [insuranceState, setInsuranceState] = useState({
    iCheck1: false,
    iCheck2: false,
    iCheck3: false,
    iCheck4: false,
    iCheck5: false,
    iCheck6: false,
    iCheck7: false,
    iCheck8: false,
    iCheck9: false,
    iCheck10: false,
    iCheck11: false,
  });

  const [q3State, setQ3State] = useState({
    q3Check1: false,
    q3Check2: false,
    q3Check3: false,
    q3Check4: false,
    q3Check5: false,
    q3Check6: false,
    q3Check7: false,
  });

  const [radio, setRadio] = useState("Savings");

  const handleChangeQ3 = (event) => {
    setQ3State({
      ...q3State,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeSaving = (event) => {
    setSavingState({
      ...savingState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeLoan = (event) => {
    setLoanState({
      ...loanState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeInsurance = (event) => {
    setInsuranceState({
      ...insuranceState,
      [event.target.name]: event.target.checked,
    });
  };

  const {
    q3Check1,
    q3Check2,
    q3Check3,
    q3Check4,
    q3Check5,
    q3Check6,
    q3Check7,
  } = q3State;

  const {
    sCheck1,
    sCheck2,
    sCheck3,
    sCheck4,
    sCheck5,
    sCheck6,
    sCheck7,
    sCheck8,
    sCheck9,
  } = savingState;

  const {
    lCheck1,
    lCheck2,
    lCheck3,
    lCheck4,
    lCheck5,
    lCheck6,
    lCheck7,
    lCheck8,
    lCheck9,
    lCheck10,
    lCheck11,
  } = loanState;

  const {
    iCheck1,
    iCheck2,
    iCheck3,
    iCheck4,
    iCheck5,
    iCheck6,
    iCheck7,
    iCheck8,
    iCheck9,
    iCheck10,
    iCheck11,
  } = insuranceState;

  const handleContinue = () => {
    const q3Checking = () => {
      // FSP RADIO SET START
      if (
        [
          q3Check1,
          q3Check2,
          q3Check3,
          q3Check4,
          q3Check5,
          q3Check6,
          q3Check7,
        ].filter((v) => v).length < 2
      ) {
        Swal.fire({
          icon: "error",
          title: "Kulang ang napiling Financial Service Providers",
          text: "Kinakailangan mo ng hindi kukulangin sa dalawa (2) upang magpatuloy.",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
      } else {
        dispatch(
          setQ3sState({
            q3Check1,
            q3Check2,
            q3Check3,
            q3Check4,
            q3Check5,
            q3Check6,
            q3Check7,
          })
        );
        navigate("/page3/Fil");
      }
      // FSP RADIO SET END
    };

    // SAVINGS RADIO SET START
    if (radio === "Savings") {
      if (
        [
          sCheck1,
          sCheck2,
          sCheck3,
          sCheck4,
          sCheck5,
          sCheck6,
          sCheck7,
          sCheck8,
          sCheck9,
        ].filter((v) => v).length < 5
      ) {
        Swal.fire({
          icon: "error",
          title: "Kulang ang napiling Product Features",
          text: "Kinakailangan mo ng hindi kukulangin sa lima (5) upang magpatuloy.",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
      } else {
        dispatch(
          setSavingsState({
            sCheck1,
            sCheck2,
            sCheck3,
            sCheck4,
            sCheck5,
            sCheck6,
            sCheck7,
            sCheck8,
            sCheck9,
          })
        );
        dispatch(setSavingOtherText(othersText));
        q3Checking();
        console.log("other: " + othersText);
      }
    }
    // SAVINGS RADIO SET END

    // LOANS RADIO SET START

    if (radio === "Loans") {
      if (
        [
          lCheck1,
          lCheck2,
          lCheck3,
          lCheck4,
          lCheck5,
          lCheck6,
          lCheck7,
          lCheck8,
          lCheck9,
          lCheck10,
          lCheck11,
        ].filter((v) => v).length < 5
      ) {
        Swal.fire({
          icon: "error",
          title: "Kulang ang napiling Product Features",
          text: "Kinakailangan mo ng hindi kukulangin sa lima (5) upang magpatuloy.",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
      } else {
        dispatch(
          setLoansState({
            lCheck1,
            lCheck2,
            lCheck3,
            lCheck4,
            lCheck5,
            lCheck6,
            lCheck7,
            lCheck8,
            lCheck9,
            lCheck10,
            lCheck11,
          })
        );
        dispatch(setSavingOtherText(othersText));
        q3Checking();
        console.log("other: " + othersText);
      }
    }

    // LOANS RADIO SET END

    // INSURANCE RADIO SET START

    if (radio === "Insurance") {
      if (
        [
          iCheck1,
          iCheck2,
          iCheck3,
          iCheck4,
          iCheck5,
          iCheck6,
          iCheck7,
          iCheck8,
          iCheck9,
          iCheck10,
          iCheck11,
        ].filter((v) => v).length < 5
      ) {
        Swal.fire({
          icon: "error",
          title: "Kulang ang napiling Product Features",
          text: "Kinakailangan mo ng hindi kukulangin sa lima (5) upang magpatuloy.",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
      } else {
        dispatch(
          setInsurancesState({
            iCheck1,
            iCheck2,
            iCheck3,
            iCheck4,
            iCheck5,
            iCheck6,
            iCheck7,
            iCheck8,
            iCheck9,
            iCheck10,
            iCheck11,
          })
        );
        dispatch(setSavingOtherText(othersText));
        q3Checking();
        console.log("other: " + othersText);
      }
    }

    // LOANS RADIO SET END
  };

  const handleChangeRadio = (event) => {
    setRadio(event.target.value);
    dispatch(setFspType(event.target.value));
  };

  const formControlLabelStyle = {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.9rem",
      padding: "0.8rem",
    },
  };

  const handleBack = () => {
    navigate("/Fil");
  };

  useEffect(() => {
    dispatch(setFspType(radio));
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className="Main__Card__FPM">
      <Grid container>
        <Grid Item xs={12} md={3} className="left-card">
          <Box className="new-logo-container">
            <img src={Logo} alt="logo" className="new-logo-img" />
          </Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <Button className="fpm--button" onClick={() => navigate("/")}>
              To English Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Gabay</p>
            <p className="instruction-text">
              Pumili ng Angkop na Produkto at Tagapagbigay ng Serbisyong
              Pinansyal.
            </p>
            <p className="instruction-text">
              Ang isang customer na may kakayahan ay alam kung aling mga feature
              ng produkto ang akma sa kanyang mga pangangailangan at kondisyon
              at kayang magkumpara ng mga feature ng produkto sa pagitan ng 2-4
              Financial Service Providers (FSPs) na aktibo sa lugar.
            </p>
            <p className="instruction-text">
              Sa bahaging ito, ibinibigay ang mga ehersisyo upang muling
              pabanguhin ang customer tungkol sa iba't ibang uri ng FSPs at ang
              mga feature ng produkto na dapat isaalang-alang sa bawat napiling
              produktong pinansyal. Isang tool na tinatawag na Financial Product
              Matrix (FPM) ay magagamit upang tulungan na organisahin ang
              impormasyon ng produkto na magpapadali sa paghahambing at
              pagraranggo sa pagitan ng FSPs batay sa partikular na mga
              kagustuhan ng customer.
            </p>
          </Box>
        </Grid>
        <Grid Item xs={12} md={9} className="right-card">
          <Box className="fpm__card">
            <Box className="fpm--opening--text1">
              <p>Pagtatakda ng Iyong Financial Product Matrix</p>
            </Box>
            <Grid container>
              <Grid item xs={12} md={6} className="child-right-card">
                <Box>
                  <Box className="fpm--question--text">
                    <p>1. Pumili ng produktong pinansyal na kailangan mo.</p>
                  </Box>
                  <Box sx={{ marginTop: "1rem" }}>
                    <FormControl>
                      <RadioGroup
                        row
                        className="fpm--radio--group"
                        defaultValue="Savings"
                      >
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Savings"
                          control={<Radio onChange={handleChangeRadio} />}
                          label="Savings"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Loans"
                          control={<Radio onChange={handleChangeRadio} />}
                          label="Loans"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Insurance"
                          control={<Radio onChange={handleChangeRadio} />}
                          label="Insurance"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
                <Box sx={{ marginTop: "2rem" }}>
                  <Box className="fpm--question--text">
                    <p>
                      2. Pumili ng hindi bababa sa limang (5) feature ng
                      produkto na mahalaga sa iyo.
                    </p>
                  </Box>
                  <Box className="fpm--checkbox--container">
                    {radio === "Savings" ? (
                      <Grid container direction="column">
                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck1}
                                    onChange={handleChangeSaving}
                                    name="sCheck1"
                                  />
                                }
                                label="Inisyal na deposito para magbukas ng account (PHP)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck2}
                                    onChange={handleChangeSaving}
                                    name="sCheck2"
                                  />
                                }
                                label="Kinakailangang dokumento o kondisyon para magbukas ng account
                                "
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={sCheck3}
                                    onChange={handleChangeSaving}
                                    name="sCheck3"
                                  />
                                }
                                label="Balance na kailangang mapanatili (PHP)
                                "
                                sx={{ ...formControlLabelStyle }}
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck4}
                                    onChange={handleChangeSaving}
                                    name="sCheck4"
                                  />
                                }
                                label="Interes sa deposito (% kada taon)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck5}
                                    onChange={handleChangeSaving}
                                    name="sCheck5"
                                  />
                                }
                                label="Halaga ng deposito upang kumita ng interes (PHP)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck6}
                                    onChange={handleChangeSaving}
                                    name="sCheck6"
                                  />
                                }
                                label="Proseso ng pagwi-withdraw
                                "
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck7}
                                    onChange={handleChangeSaving}
                                    name="sCheck7"
                                  />
                                }
                                label="Insurance sa deposito
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck8}
                                    onChange={handleChangeSaving}
                                    name="sCheck8"
                                  />
                                }
                                label="Bayarin at singil (PHP)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={sCheck9}
                                    onChange={handleChangeSaving}
                                    name="sCheck9"
                                  />
                                }
                                label="Iba pa:
                                "
                              />
                              <TextField
                                variant="standard"
                                placeholder=" I-type dito… "
                                className="fpm--checkbox--other--text"
                                onChange={(e) => setOthersText(e.target.value)}
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : null}

                    {radio === "Loans" ? (
                      <Grid container direction="column">
                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck1}
                                    onChange={handleChangeLoan}
                                    name="lCheck1"
                                  />
                                }
                                label="Halaga ng loan (PHP)
"
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck2}
                                    onChange={handleChangeLoan}
                                    name="lCheck2"
                                  />
                                }
                                label="Kinakailangang dokumento o kondisyon para makakuha ng loan
                                "
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={lCheck3}
                                    onChange={handleChangeLoan}
                                    name="lCheck3"
                                  />
                                }
                                label="Bundled o pinagsamang produktong pinansyal (hal. savings, insurance)
                                "
                                sx={{ ...formControlLabelStyle }}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={lCheck4}
                                    onChange={handleChangeLoan}
                                    name="lCheck4"
                                  />
                                }
                                label="Paraan ng pagbabayad at regular na halagang prinsipal (hal. PHP 1,000 kada buwan)
                                "
                                sx={{ ...formControlLabelStyle }}
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck5}
                                    onChange={handleChangeLoan}
                                    name="lCheck5"
                                  />
                                }
                                label="Rate ng interes (% kada buwan)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck6}
                                    onChange={handleChangeLoan}
                                    name="lCheck6"
                                  />
                                }
                                label="Effective Interest Rate (EIR, % kada taon)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck7}
                                    onChange={handleChangeLoan}
                                    name="lCheck7"
                                  />
                                }
                                label="Iba pang bayarin at singil (PHP)
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck8}
                                    onChange={handleChangeLoan}
                                    name="lCheck8"
                                  />
                                }
                                label="Pinagsamang hindi pinansyal na mga produkto nang walang bayad sa mga kliyente (hal. financial education, skills training, atbp.)
                                "
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck9}
                                    onChange={handleChangeLoan}
                                    name="lCheck9"
                                  />
                                }
                                label="Collateral
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck10}
                                    onChange={handleChangeLoan}
                                    name="lCheck10"
                                  />
                                }
                                label="Kondisyon ng pagbabayad
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={lCheck11}
                                    onChange={handleChangeLoan}
                                    name="lCheck11"
                                  />
                                }
                                label="Iba pa:"
                              />
                              <TextField
                                variant="standard"
                                placeholder="I-type dito…"
                                className="fpm--checkbox--other--text"
                                onChange={(e) => setOthersText(e.target.value)}
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : (
                      ``
                    )}

                    {radio === "Insurance" ? (
                      <Grid container direction="column">
                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck1}
                                    onChange={handleChangeInsurance}
                                    name="iCheck1"
                                  />
                                }
                                label="Kabuuang premium na dapat bayaran (PHP)"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={iCheck2}
                                    onChange={handleChangeInsurance}
                                    name="iCheck2"
                                  />
                                }
                                label="Delivery channel - para mag-claim
                                "
                                sx={{ ...formControlLabelStyle }}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={iCheck3}
                                    onChange={handleChangeInsurance}
                                    name="iCheck3"
                                  />
                                }
                                label="Kondisyon ng pagbabayad
                                "
                                sx={{ ...formControlLabelStyle }}
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck4}
                                    onChange={handleChangeInsurance}
                                    name="iCheck4"
                                  />
                                }
                                label="Paraan ng pagbabayad at halaga ng premium sa installment
                                "
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck5}
                                    onChange={handleChangeInsurance}
                                    name="iCheck5"
                                  />
                                }
                                label="Kinakailangang dokumento o kondisyon para makakuha ng policy
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck6}
                                    onChange={handleChangeInsurance}
                                    name="iCheck6"
                                  />
                                }
                                label="Delivery channel - para bumili ng isang insurance policy
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck7}
                                    onChange={handleChangeInsurance}
                                    name="iCheck7"
                                  />
                                }
                                label="Delivery channel - para bayaran ang regular na premium
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck8}
                                    onChange={handleChangeInsurance}
                                    name="iCheck8"
                                  />
                                }
                                label="Sakop na halaga
                                "
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <FormControl variant="standard">
                            <FormGroup>
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck9}
                                    onChange={handleChangeInsurance}
                                    name="iCheck9"
                                  />
                                }
                                label="Kinakailangang dokumento o kondisyon para mag-file ng claim
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck10}
                                    onChange={handleChangeInsurance}
                                    name="iCheck10"
                                  />
                                }
                                label="Karaniwang bilang ng araw upang ayusin ang claim
                                "
                              />
                              <FormControlLabel
                                sx={{ ...formControlLabelStyle }}
                                control={
                                  <Checkbox
                                    checked={iCheck11}
                                    onChange={handleChangeInsurance}
                                    name="iCheck11"
                                  />
                                }
                                label="Iba pa:"
                              />
                              <TextField
                                variant="standard"
                                placeholder="I-type dito…"
                                className="fpm--checkbox--other--text"
                                onChange={(e) => setOthersText(e.target.value)}
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    ) : (
                      ``
                    )}
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} className="child-right-card">
                <Box>
                  <Box className="fpm--question--text">
                    <p>
                      3. Pumili ng hindi bababa sa dalawang (2) Financial
                      Service Providers (FSP) na nag-aalok ng iyong
                      kinakailangang produktong pinansyal.
                    </p>
                  </Box>
                  <Box
                    sx={{
                      marginTop: "1rem",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <FormControl variant="standard">
                      <FormGroup>
                        <FormControlLabel
                          sx={{ ...formControlLabelStyle }}
                          control={
                            <Checkbox
                              checked={q3Check1}
                              onChange={handleChangeQ3}
                              name="q3Check1"
                            />
                          }
                          label="Bank"
                        />
                        {radio === "Savings" || radio === "Insurance" ? (
                          ``
                        ) : (
                          <FormControlLabel
                            sx={{ ...formControlLabelStyle }}
                            control={
                              <Checkbox
                                checked={q3Check4}
                                onChange={handleChangeQ3}
                                name="q3Check4"
                              />
                            }
                            label="Lending and Finance Companies"
                          />
                        )}
                        {radio === "Loans" || radio === "Savings" ? (
                          ``
                        ) : (
                          <FormControlLabel
                            sx={{ ...formControlLabelStyle }}
                            control={
                              <Checkbox
                                checked={q3Check7}
                                onChange={handleChangeQ3}
                                name="q3Check7"
                              />
                            }
                            label="Mutual Benefit Associations"
                          />
                        )}
                      </FormGroup>
                    </FormControl>

                    <FormControl variant="standard">
                      <FormGroup>
                        {radio === "Loans" || radio === "Savings" ? (
                          ``
                        ) : (
                          <FormControlLabel
                            sx={{ ...formControlLabelStyle }}
                            control={
                              <Checkbox
                                checked={q3Check5}
                                onChange={handleChangeQ3}
                                name="q3Check5"
                              />
                            }
                            label="Insurance Companies"
                          />
                        )}
                        <FormControlLabel
                          sx={{ ...formControlLabelStyle }}
                          control={
                            <Checkbox
                              checked={q3Check2}
                              onChange={handleChangeQ3}
                              name="q3Check2"
                            />
                          }
                          label="Cooperatives"
                        />
                      </FormGroup>
                    </FormControl>

                    <FormControl variant="standard">
                      <FormGroup>
                        <FormControlLabel
                          sx={{ ...formControlLabelStyle }}
                          control={
                            <Checkbox
                              checked={q3Check3}
                              onChange={handleChangeQ3}
                              name="q3Check3"
                            />
                          }
                          label="Microfinance NGOs"
                        />
                        <FormControlLabel
                          sx={{ ...formControlLabelStyle }}
                          control={
                            <Checkbox
                              checked={q3Check6}
                              onChange={handleChangeQ3}
                              name="q3Check6"
                            />
                          }
                          label="Digital Financial Service Providers"
                        />
                      </FormGroup>
                    </FormControl>
                  </Box>
                </Box>
                <Box>
                  <Box
                    className="fpm__button__container"
                    sx={{ display: "flex", gap: "1rem" }}
                  >
                    <Button
                      className="fpm--button-2"
                      onClick={() => handleBack()}
                    >
                      Bumalik
                    </Button>
                    <Button
                      className="fpm--button"
                      onClick={() => handleContinue()}
                      sx={{ width: "50%" }}
                    >
                      Sunod
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default FpmPage2Fil;
